import React from 'react';
import EnrollmentFormPopup from './EnrollmentFormPopup';

const PageWrapper = ({ children }) => {
  return (
    <>
      {children}
      <EnrollmentFormPopup />
    </>
  );
};

export default PageWrapper;